define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");

    /**
     * Model for a Youtube widget.
     *
     * @class YoutubeWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("YouTube widget", {
        defaults: _.defaults({
            type: "youtube",
            videoID: null,
            autoplay: false,
            controls: true,
            loop: false,
            mute: false
        }, AbstractWidgetModel.prototype.defaults),

        getPlayerVars() {
            const playerVars = {
                color: "white",
                modestbranding: 0,
                rel: 0,
                html5: 1,
                showinfo: 0,
                // Settings
                controls: +this.get("controls"), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Arithmetic_Operators#.2B_%28Unary_Plus%29
                loop: +this.get("loop")
            };

            if (playerVars.loop) {
                playerVars.playlist = this.get("videoID");
            }

            return playerVars;
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/youtubeWidget/YouTubeWidgetModel.js